module.exports = __webpack_public_path__ + "img/top3.cf0b08c6.png";